import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { messageError } from '../../constants';
import { StructuredOperationOperationScenarioSection } from '../StructuredOperationOperationScenarioSection';
import { OperationSectionProps } from '../StructuredOperationSubDetailsSection';

export const StructuredOperationOperationSection: React.FC<OperationSectionProps> = ({
  scenarios,
  table,
}) => {
  const data =
    table?.content?.rows?.map((row) => ({
      label: row?.scenario,
      variation: row?.variation,
      return: row?.valueReturn,
    })) || [];

  return (
    <VStack>
      <Box w={'full'} bg={'neutral.lightest'} h={'0.5'} my={Spacing['inline.xxxs']} />
      <VStack space={Spacing['inline.xxxs']}>
        {scenarios?.map((scenario) => (
          <VStack space={Spacing['inline.xxxs']} key={scenario.title}>
            <Text
              color={'brand.primary.principal'}
              variant="bold"
              fontSize={Typography['fontsize.lg']}>
              {scenario.title}
            </Text>
            <Text
              color={'brand.primary.principal'}
              variant="regular"
              fontSize={Typography['fontsize.md']}>
              {scenario.content}
            </Text>
          </VStack>
        ))}
        <VStack space={Spacing['inline.xxs']}>
          <Text
            color={'brand.primary.principal'}
            variant="bold"
            fontSize={Typography['fontsize.lg']}>
            {table?.title || messageError}
          </Text>
          <Box w={'full'} bg={'neutral.lightest'} h={'0.5'} />
          <StructuredOperationOperationScenarioSection
            data={data}
            headers={['Cenário', 'Variação', 'Retorno']}
          />
          <Box w={'full'} bg={'neutral.lightest'} h={'0.5'} />
          <Text
            color={'brand.primary.principal'}
            variant="regular"
            fontSize={Typography['fontsize.md']}>
            {table?.footerTable || messageError}
          </Text>
        </VStack>
      </VStack>
    </VStack>
  );
};
